// src/scenes/home/index.jsx
import React from "react";
import { Box, Container, Typography, Button, Paper } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import dphLogo from "../../assets/logo-dph.png";

export default function Landing() {
    const theme = useTheme();

    return (
        <Box
            sx={(t) => ({
                minHeight: "100vh",
                background: t.gradients?.hero || `linear-gradient(135deg, ${t.palette.background.default} 0%, #fff 60%)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 2,
            })}
        >
            <Container maxWidth="sm" sx={{ textAlign: "center" }}>
                <Paper
                    elevation={6}
                    sx={{
                        p: 4,
                        borderRadius: 4,
                        backdropFilter: "blur(8px)",
                        backgroundColor: "rgba(255,255,255,0.6)",
                    }}
                >
                    <Box component="img" src={dphLogo} alt="SC DPH Logo" sx={{ width: 120, mb: 3 }} />

                    <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
                        South Carolina DPH Forms
                    </Typography>
                    <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
                        Public Health Forms Management
                    </Typography>

                    <Typography variant="body1" color="text.secondary" sx={{ mb: 4, px: 2, lineHeight: 1.6 }}>
                        The SC Department of Health provides an online portal for submitting,
                        tracking, and digitally signing public health forms. Secure workflows,
                        configurable approvals, and automated notifications help ensure timely
                        processing and complete visibility for every submission.
                    </Typography>

                    <Button
                        component={RouterLink}
                        to="/login"
                        variant="contained"
                        size="large"
                        sx={(t) => ({
                            px: 6,
                            py: 1.5,
                            fontSize: "1rem",
                            background: t.gradients?.cta || t.palette.primary.main,
                            boxShadow: `0 0 12px ${t.palette.primary.main}`,
                        })}
                    >
                        Sign In
                    </Button>
                </Paper>
            </Container>
        </Box>
    );
}
